import React, { useEffect, useState } from 'react';
import {
    CircularProgress,
    Grid, Typography
} from "@material-ui/core/";
import { Link } from 'react-router-dom';

import TermsDeclarationsForm from '../../../../../forms/medicoAssistente/TermsDeclarationsForm';
import FormBase from '../../../../../forms/FormBase';
import Controls from '../../../../../components/controls/Controls';
import TermsDeclarationsService from '../../../../../services/TermsDeclarationsService';
import TermsDeclarations from '../../../../../models/TermsDeclarations';
import { ModalHandle } from '../../../../../components/controls/Modal';
import TmpHtmlContentCustom from '../../../../../components/tempo/TmpHtmlContentCustom/TmpHtmlContentCustom';


interface AssistantDoctorDeclarationProps {
    TermsDeclarationsForm: TermsDeclarationsForm;
    onInputChange: (name: string, form: FormBase, value: any) => void
}

export default function AssistantDoctorDeclaration(props: AssistantDoctorDeclarationProps) {

    const [text, setText] = useState<string>("")
    const [title, setTitle] = useState<string>("")
    const [id, setId] = useState<number>(0)
    const [checkedTerm, setCheckedTerm] = useState(props.TermsDeclarationsForm.AssistantDoctorDeclaration.Value.Checked);

    useEffect(() => {

        TermsDeclarationsService.getCurrentTermsDeclarations("MEDICO_ASSISTENTE_TERMO").then(e => {
            if (e) {
                setText(e.description)
                setTitle(e.title)
                setId(e.textId);
            }
        })

    }, [])

    const modalRef = React.createRef<ModalHandle>();

    const handleOpenModalChild = () => {
        modalRef.current?.handleOpen()
    };

    const handleCheckdTerm = (e: any) => {
        setCheckedTerm(e.target.value);
        props.onInputChange("AssistantDoctorDeclaration", props.TermsDeclarationsForm, new TermsDeclarations(id, e.target.value));
    }

    return (
        <Grid item xs={12} sm={12}>

            {
                id === undefined || id === 0 ?
                    <Grid container justifyContent="center" style={{ width: "85%" }} >
                        <CircularProgress />
                    </Grid>
                    :
                    <Controls.Checkbox
                        name="AssistantDoctorDeclaration"
                        labelComponent={
                            <div>
                                <span>Li e estou de acordo com a  </span>
                                <Link to={'#'} onClick={() => handleOpenModalChild()}>Declaração de Médico Assitente.</Link>
                            </div>
                        }
                        value={checkedTerm}
                        onChange={handleCheckdTerm}
                    />
            }


            <Controls.Modal ref={modalRef} title={title}>

                <Typography variant="body1" gutterBottom component="div">
                    <TmpHtmlContentCustom html={text} />
                </Typography>
            </Controls.Modal>
        </Grid>
    );
}

